
// import React, { useState, useRef, useEffect } from "react";
// import { FaSearch } from "react-icons/fa";
// // import "./SearchableList.css";

// interface SearchableListProps {
//   items: string[];
//   selectedItems: string[];
//   onSelectionChange: (selectedItems: string[]) => void;
//   onClose: () => void;
// }

// const SearchAndSelectList: React.FC<SearchableListProps> = ({
//   items,
//   selectedItems,
//   onSelectionChange,
//   onClose,
// }) => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
//         onClose();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [onClose]);


//   const filteredItems = items.filter((item) =>
//     String(item).toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const toggleItemSelection = (item: string) => {
//     const updatedSelection = selectedItems.includes(item)
//       ? selectedItems.filter((i) => i !== item)
//       : [...selectedItems, item];

//     onSelectionChange(updatedSelection);
//   };

//   const handleSelectAll = () => {
//     if (selectedItems.length === items.length) {
//       onSelectionChange([]); // Deselect all
//     } else {
//       onSelectionChange(items); // Select all
//     }
//   };

//   return (
//     <div className="searchable-list" ref={dropdownRef}>
//       <div className="search-box">
//         <FaSearch className="search-icon" size={16} color="gray" />
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           className="search-input"
//           placeholder="Search here"
//           onClick={(e) => e.stopPropagation()}
//         />
//       </div>

//       <div className="items-container">
//         {/* Select All Option */}
//         <label className="list-item">
//           <input
//             type="checkbox"
//             checked={selectedItems.length === items.length}
//             onChange={handleSelectAll}
//             className="hidden-checkbox"
//           />
//           <div className={`custom-checkbox ${selectedItems.length === items.length ? "checked" : ""}`}>
//             {selectedItems.length === items.length && (
//               <svg className="check-icon" viewBox="0 0 20 20" fill="white">
//                 <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />
//               </svg>
//             )}
//           </div>
//           <span className="item-text"><strong>Select All</strong></span>
//         </label>

//         {/* Filtered Items */}
//         {filteredItems.length > 0 ? (
//           filteredItems.map((item, index) => (
//             <label key={index} className="list-item">
//               <input
//                 type="checkbox"
//                 checked={selectedItems.includes(item)}
//                 onChange={() => toggleItemSelection(item)}
//                 className="hidden-checkbox"
//                 onClick={(e) => e.stopPropagation()}
//               />
//               <div className={`custom-checkbox ${selectedItems.includes(item) ? "checked" : ""}`}>
//                 {selectedItems.includes(item) && (
//                   <svg className="check-icon" viewBox="0 0 20 20" fill="white">
//                     <path d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />
//                   </svg>
//                 )}
//               </div>
//               <span className="item-text">{item}</span>
//             </label>
//           ))
//         ) : (
//           <p className="no-items">No items found.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchAndSelectList;




import React, { useState, useRef, useEffect } from "react";
import { FaSearch } from "react-icons/fa";

interface SearchableListProps {
  items: string[];
  selectedItems: string[];
  onSelectionChange: (selectedItems: string[]) => void;
  onClose: () => void;
}

const SearchAndSelectList: React.FC<SearchableListProps> = ({
  items,
  selectedItems,
  onSelectionChange,
  onClose,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  const filteredItems = items.filter((item) =>
    String(item).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleItemSelection = (item: string) => {
    const updatedSelection = selectedItems.includes(item)
      ? selectedItems.filter((i) => i !== item)
      : [...selectedItems, item];
    onSelectionChange(updatedSelection);
  };

  const handleSelectAll = () => {
    if (selectedItems.length === items.length) {
      onSelectionChange([]);
    } else {
      onSelectionChange(items);
    }
  };

  return (
    <div
      ref={dropdownRef}
      className="p-3 w-64 max-h-72 overflow-y-auto rounded-lg border border-gray-200 shadow-md bg-white text-sm"
    >
      {/* Search Box */}
      <div className="flex items-center mb-3 border border-gray-300 rounded-md px-2 py-1 bg-gray-50">
        <FaSearch className="text-gray-400 mr-2" size={14} />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full outline-none bg-transparent text-gray-700"
          placeholder="Search..."
          onClick={(e) => e.stopPropagation()}
        />
      </div>

      {/* Select All */}
      <label className="flex items-center p-2 rounded-md hover:bg-indigo-100 cursor-pointer">
        <input
          type="checkbox"
          checked={selectedItems.length === items.length}
          onChange={handleSelectAll}
          className="mr-2"
        />
        <span className="font-semibold text-gray-700">Select All</span>
      </label>

      {/* Items */}
      <div className="mt-2">
        {filteredItems.length > 0 ? (
          filteredItems.map((item, index) => (
            <label
              key={index}
              className="flex items-center p-2 rounded-md hover:bg-indigo-50 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedItems.includes(item)}
                onChange={() => toggleItemSelection(item)}
                className="mr-2"
                onClick={(e) => e.stopPropagation()}
              />
              <span className="text-gray-700">{item}</span>
            </label>
          ))
        ) : (
          <p className="p-2 text-gray-500 text-center">No items found.</p>
        )}
      </div>
    </div>
  );
};

export default SearchAndSelectList;
